<button class="td-wb-date-picker-toggle"
        id="slideDatePickerOpenCalendarButton"
        [disabled]="disabled"
        [attr.aria-label]="'tdWb.datePicker.OPEN_CALENDAR' | tdWbTranslate"
        tdWbIconButton
        tdWbIconButtonSize="small"
        tdWbIconButtonShape="circle"
        tdWbIconButtonBackground="clear-tint"
        type="button"
        (click)="toggleCalendar()">
  <td-wb-icon class="td-wb-date-picker-toggle__icon"
              iconId="calendar--small"
              size="19" />
</button>
